import { VehicleAlert } from "features/CenterContent/shared/TilsynAlerts/schema";
import TilsynAlertRow from "features/CenterContent/shared/TilsynAlerts/TilsynAlertRow";
import { sortFunction } from "features/CenterContent/shared/TilsynAlerts/utils";
import React from "react";
import { NoDataMessage } from "shared/components/feedback/NoDataMessage/NoDataMessage";
import { TableSkeleton } from "shared/components/feedback/SkeletonLoader/TableSkeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableColumnHeader,
  TableHeader,
  TableRow,
} from "shared/components/Spor";
import styled, { useTheme } from "styled-components";

const minimizedColumns = ["Individ", "Aktivert", "Type", "Tiltak"];
const TableColumns = ["Togsett", ...minimizedColumns, "Tilstand", " "]; // empty column title for the action column

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

interface TilsynAlertProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  alerts: VehicleAlert[] | undefined;
  isLoading: boolean;
  isSuccess: boolean;
  fullSize?: boolean;
}

const TilsynAlerts = ({
  alerts,
  isLoading,
  isSuccess,
  fullSize = false,
  ...props
}: TilsynAlertProps) => {
  const theme = useTheme();

  const columns = fullSize ? TableColumns : minimizedColumns;

  const dataToShow = alerts && alerts.length > 0;

  return (
    <Container {...props}>
      <Table size="sm" flexDirection="column">
        <TableHeader
          position="sticky"
          top="0"
          backgroundColor={theme.colorBackgroundSecondary}
        >
          <TableRow>
            {columns.map((column) => (
              <TableColumnHeader key={column} border="none" p="9px 18px">
                {column}
              </TableColumnHeader>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading && (
            <TableSkeleton numOfRows={10} numOfColumns={columns.length} />
          )}

          {isSuccess && dataToShow
            ? alerts
                .toSorted(sortFunction)
                .map((alert) => (
                  <TilsynAlertRow
                    key={alert.alertId}
                    alert={alert}
                    fullSize={fullSize}
                  />
                ))
            : isSuccess &&
              !dataToShow && (
                <TableRow>
                  <TableCell colSpan={TableColumns.length} p="30px">
                    <NoDataMessage reason="Det er ingen aktive alarmer i Tilsyn for øyeblikket" />
                  </TableCell>
                </TableRow>
              )}
        </TableBody>
      </Table>
    </Container>
  );
};

export default TilsynAlerts;
